import { SymbolTable } from 'app/modules/rulesAdvanced/lib/SymbolTable';
import { ValueTypes } from 'app/modules/rulesAdvanced/models';

export const ACTION_EVENT_ADVANCED_SYMBOLS: SymbolTable = Object.freeze({
  txn_instrument_id: {
    type: ValueTypes.FIELD,
    field: 'txn_instrument_id',
    label: 'Instrument ID',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'client_fingerprint.client_fingerprint': {
    type: ValueTypes.FIELD,
    field: 'client_fingerprint.client_fingerprint',
    label: 'Client fingerprint',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'ip_address.ip_address': {
    type: ValueTypes.FIELD,
    field: 'ip_address.ip_address',
    label: 'IP address',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  ip_is_bot: {
    type: ValueTypes.FIELD,
    field: 'ip_is_bot',
    label: 'IP uses bot',
    model: 'action_event',
    datatype: 'boolean',
    cardinality: 'many',
  },
  ip_is_vpn: {
    type: ValueTypes.FIELD,
    field: 'ip_is_vpn',
    label: 'IP uses VPN',
    model: 'action_event',
    datatype: 'boolean',
    cardinality: 'many',
  },
  ip_is_proxy: {
    type: ValueTypes.FIELD,
    field: 'ip_is_proxy',
    label: 'IP uses proxy',
    model: 'action_event',
    datatype: 'boolean',
    cardinality: 'many',
  },
  ip_is_tor: {
    type: ValueTypes.FIELD,
    field: 'ip_is_tor',
    label: 'IP uses Tor',
    model: 'action_event',
    datatype: 'boolean',
    cardinality: 'many',
  },
  'geolocation.country': {
    type: ValueTypes.FIELD,
    field: 'geolocation.country',
    label: 'Geolocation / Country',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'geolocation.city': {
    type: ValueTypes.FIELD,
    field: 'geolocation.city',
    label: 'Geolocation / City',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'geolocation.postal_code': {
    type: ValueTypes.FIELD,
    field: 'geolocation.postal_code',
    label: 'Geolocation / Postal code',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'geolocation.longitude': {
    type: ValueTypes.FIELD,
    field: 'geolocation.longitude',
    label: 'Geolocation / Longitude',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
  'geolocation.latitude': {
    type: ValueTypes.FIELD,
    field: 'geolocation.latitude',
    label: 'Geolocation / Latitude',
    model: 'action_event',
    datatype: 'string',
    cardinality: 'many',
  },
});
